// extracted by mini-css-extract-plugin
export default {"faq-wrapper":"FAQ_faq-wrapper__Qd0Gz","title":"FAQ_title__qV1OD"};